var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_371_598)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F3FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.864 34.256C22.5413 34.256 21.3253 34 20.216 33.488C19.128 32.9547 18.232 32.2507 17.528 31.376C16.824 30.5013 16.4187 29.5093 16.312 28.4H18.744C18.8507 29.0613 19.1493 29.6587 19.64 30.192C20.1307 30.7253 20.7387 31.152 21.464 31.472C22.2107 31.7707 23.0107 31.92 23.864 31.92C25.3787 31.92 26.552 31.536 27.384 30.768C28.2373 30 28.664 29.072 28.664 27.984C28.664 27.2587 28.4613 26.5973 28.056 26C27.672 25.3813 27.1387 24.8907 26.456 24.528C25.7733 24.144 24.984 23.952 24.088 23.952H21.656V21.744H23.8C24.5467 21.744 25.2293 21.6053 25.848 21.328C26.488 21.0293 27 20.624 27.384 20.112C27.768 19.5787 27.96 18.9707 27.96 18.288C27.96 17.2853 27.5973 16.4747 26.872 15.856C26.168 15.216 25.1227 14.896 23.736 14.896C22.4347 14.896 21.3893 15.1947 20.6 15.792C19.832 16.3893 19.3733 17.0933 19.224 17.904H16.888C16.9947 17.0293 17.3147 16.1867 17.848 15.376C18.4027 14.5653 19.1707 13.8933 20.152 13.36C21.1333 12.8267 22.3067 12.56 23.672 12.56C25.7627 12.56 27.3947 13.0933 28.568 14.16C29.7627 15.2053 30.36 16.5493 30.36 18.192C30.36 18.896 30.1893 19.568 29.848 20.208C29.528 20.8267 29.1227 21.36 28.632 21.808C28.1413 22.256 27.6507 22.5547 27.16 22.704C28.3973 23.1733 29.3573 23.8773 30.04 24.816C30.7227 25.7547 31.064 26.7893 31.064 27.92C31.064 29.1787 30.744 30.288 30.104 31.248C29.464 32.1867 28.6 32.9227 27.512 33.456C26.424 33.9893 25.208 34.256 23.864 34.256Z",
    fill: "#1778E1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_371_598"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step-3.32dd042a.svg";
export { ForwardRef as ReactComponent };